export function percentage(partialValue: number, totalValue: number): number {
  if (totalValue === 0) {
    return 0;
  }

  return Number(((100 * partialValue) / totalValue).toFixed(1));
}
